import { profilesApi } from '@/api';
import { useToast } from '@/store/useToast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ErrorNotificationIcon, SuccessNotificationIcon } from '@/assets/icons';

export const useBlockedProfileById = () => {
    const queryClient = useQueryClient();

    const showToast = useToast((state) => state.show);

    const mutation = useMutation({
        mutationFn: profilesApi.blockProfileById,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profiles'] });
            showToast({
                // type success
                icon: <SuccessNotificationIcon />,
                msg: 'Профиль успешно заблокирован'
            });
        },
        onError: (error) => {
            console.error('Error blocked profile:', error);
            showToast({
                // type error
                icon: <ErrorNotificationIcon />,
                msg: 'Ошибка блокировки профиля'
            });
        },
    });

    return mutation;
};
